import { CircleAlertIcon, CircleCheckIcon, CircleDashedIcon } from 'lucide-react';
import { StreamMessageEvents } from '@/entities/ai';
import { SpinningIcon } from '@/shared/ui';
import TaskProgress from '@/shared/assets/images/TaskProgress.svg';
import { useTranslation } from 'react-i18next';

// The size of the progress image, so a step does not change size when it finishes.
const STATUS_ICON_CLASSES = 'size-4.5 shrink-0';

export const AgentTaskIcon = ({
  data,
  settled = false,
}: {
  data: StreamMessageEvents;
  /** The reply has stopped streaming, so a step that never finished was cut short. */
  settled?: boolean;
}) => {
  const { t } = useTranslation('chats');

  const type = data.type;

  const complete = (
    <CircleCheckIcon
      aria-hidden
      data-testid="agent-task-icon-complete"
      className={`${STATUS_ICON_CLASSES} text-positive-foreground`}
    />
  );

  const failed = (
    <CircleAlertIcon
      aria-hidden
      data-testid="agent-task-icon-error"
      className={`${STATUS_ICON_CLASSES} text-destructive`}
    />
  );

  const inProgress = (
    <SpinningIcon
      src={TaskProgress}
      alt={t('chats.agentTaskIcon.taskInProgress')}
      width={18}
      height={18}
    />
  );

  if (type === 'data-agentComplete' || type === 'data-toolComplete') {
    return complete;
  }

  if (type === 'data-agentError' || type === 'data-toolError') {
    return failed;
  }

  // Everything else (including the tool/agent start events) is still running, unless the reply
  // stopped streaming without it finishing.
  if (settled) {
    return (
      <CircleDashedIcon
        aria-hidden
        data-testid="agent-task-icon-stopped"
        className={`${STATUS_ICON_CLASSES} text-muted-foreground`}
      />
    );
  }
  return inProgress;
};
